export default __webpack_public_path__ + "static/media/case-management.332e1f75.svg";